import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import RecurlyProvider from '@/components/Providers/RecurlyProvider'
import { useSignUp } from '@/components/Providers/SignUpProvider'
import SelectPlan from '@/components/Pages/SignUp/SelectPlan'
import Authenticate from '@/components/Pages/SignUp/Authenticate'
import NewUser from '@/components/Pages/SignUp/NewUser'
import Billing from '@/components/Pages/SignUp/Billing'
import ExistingUser from '@/components/Pages/SignUp/ExistingUser'
import ResetPassword from '@/components/Pages/SignUp/ResetPassword'
import Upsell from '@/components/Pages/SignUp/Upsell'
import Spinner from '@/components/common/FullScreenSpinner'

import AccountSetupFrame from './AccountSetupFrame'

const SignUpForm = ({ csrfToken }) => {
  const { navigation, isLoading, setCsrfToken } = useSignUp()

  useEffect(() => {
    if (csrfToken) {
      setCsrfToken(csrfToken)
    }
  }, [])

  if (!csrfToken) { return (
    <Spinner>
      <h2>Please reload the page</h2>
    </Spinner>
  ) }

  if (isLoading) { return (
    <Spinner>
      <h2>Loading</h2>
      <p>Please wait...</p>
    </Spinner>
  ) }

  // The email step and the profile step are two machine states rendered inside
  // one frame, so they are selected here and wrapped together rather than taken
  // from the map below. Splitting the switch is what lets the frame keep the
  // same position in the tree across the transition between them.
  const accountSetup = {
    authenticate: <Authenticate />,
    newUser: <NewUser />,
  }[navigation.currentStep]

  return (
    <RecurlyProvider>
      {accountSetup ? <AccountSetupFrame>{accountSetup}</AccountSetupFrame> : (
        {
          existingUser: <ExistingUser />,
          resetPassword: <ResetPassword />,
          upsell: <Upsell />,
          selectPlan: <SelectPlan />,
          billing: <Billing />,
        }[navigation.currentStep]
      )}
    </RecurlyProvider>
  )
}

SignUpForm.propTypes = {
  csrfToken: PropTypes.string,
}

export default SignUpForm
